import { DataList } from '@tiendanube/components';
import { ChevronRightIcon } from '@tiendanube/icons';
import Text from 'commons/components/LegacyText';
import Stack from 'commons/components/Stack';

const { Row, Cell } = DataList;

function MonthRowSkeleton(): JSX.Element {
  return (
    <Row id="skeleton-row">
      <Cell width={70}>
        <Stack column align="flex-start">
          <Text.Skeleton />
          <Text.Skeleton />
        </Stack>
      </Cell>
      <Cell width={30} alignRight>
        <ChevronRightIcon />
      </Cell>
    </Row>
  );
}

export default MonthRowSkeleton;
